'use client';

import { c as _c } from "react/compiler-runtime";
import MenuCover from '@/app/_components/MenuCover';
import MainMenu from '@/app/_layout/MainMenu';
import MobileMenu from '@/app/_layout/MobileMenu';
import SiteBranding from '@/app/_layout/SiteBranding';
import IconNav from '@/app/_layout/IconNav';
import { useAppContext } from '@/app/_lib/_context';
const HeaderNav = t0 => {
  const $ = _c(17);
  const {
    menuItems,
    dropdownSlots
  } = t0;
  const {
    mobileMenuOpen,
    openMobileMenu,
    closeMobileMenu
  } = useAppContext();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <SiteBranding />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== closeMobileMenu || $[2] !== menuItems || $[3] !== mobileMenuOpen || $[4] !== openMobileMenu) {
    t2 = <MobileMenu menuItems={menuItems} mobileMenuOpen={mobileMenuOpen} openMobileMenu={openMobileMenu} closeMobileMenu={closeMobileMenu} />;
    $[1] = closeMobileMenu;
    $[2] = menuItems;
    $[3] = mobileMenuOpen;
    $[4] = openMobileMenu;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== dropdownSlots || $[7] !== menuItems) {
    t3 = <MainMenu menuItems={menuItems} dropdownSlots={dropdownSlots} autoCloseDelay={650} />;
    $[6] = dropdownSlots;
    $[7] = menuItems;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== closeMobileMenu || $[10] !== mobileMenuOpen || $[11] !== openMobileMenu) {
    t4 = <IconNav closeMobileMenu={closeMobileMenu} mobileMenuOpen={mobileMenuOpen} openMobileMenu={openMobileMenu} />;
    $[9] = closeMobileMenu;
    $[10] = mobileMenuOpen;
    $[11] = openMobileMenu;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t2 || $[14] !== t3 || $[15] !== t4) {
    t5 = <><div className="w-full flex items-end group-[.collapsed]/header:items-center justify-between site-padding justify-items-end pt-2 pb-3 group-[.collapsed]/header:pt-0 group-[.collapsed]/header:pb-0 lg:pt-0 lg:pb-0">{t1}{t2}{t3}{t4}</div></>;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
};
export default HeaderNav;